import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
export var _DialogSelectPlayerProfilePictureInfo = React.memo(function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.profilePictures, onClose: function () { return onClose(IdModal.PlayerProfilePictureSelectionInfo); }, className: "" + IdStyles.ModalBackgroundInfo },
        React.createElement("div", { className: "w100 h100 flex flex--aligned profile-pictures__info-text" },
            React.createElement(TextLoca, { id: IdLoca.profilepictures_info, className: IdStyles.TextBoldPrimary }))));
});
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClose: actionModalClose,
    }, dispatch);
};
export var DialogSelectPlayerProfilePictureInfo = connect(undefined, mapDispatch)(_DialogSelectPlayerProfilePictureInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/profile-picture/DialogSelectPlayerProfilePictureInfo.tsx
// module id = 2883
// module chunks = 3